import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, toRefs, nextTick, computed ,onMounted, onBeforeUnmount} from 'vue';
import { StreamInfo,UserInfo } from '@/stores/room';
import defaultAvatar from '@/assets/img/avatar.png';
import TUIRoomCore, { ETUIStreamType, TRTCVideoFillMode ,ETUIRoomEvents} from '../../tui-room-core';
import { useBasicStore } from '../../../stores/basic';
import logger from '../../tui-room-core/common/logger/logs';
import AudioIcon from '../base/AudioIcon.vue';
import SvgIcon from '../common/SvgIcon.vue';

import { storeToRefs } from 'pinia';
interface Props {
  stream: StreamInfo,
  enlargedStreamStyle:any,
  streamStyle:any,
  enlargeDomId?: string,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamRegion',
  props: {
    stream: null,
    enlargedStreamStyle: null,
    streamStyle: null,
    enlargeDomId: null
  },
  setup(__props: any) {

const props = __props as {
  stream: StreamInfo,
  enlargedStreamStyle:any,
  streamStyle:any,
  enlargeDomId?: string,
}

const logPrefix = '[StreamRegion]';
const basicStore = useBasicStore();


 
  



// const props = withDefaults(defineProps<Props>(),{});




const { layout,userId } = storeToRefs(basicStore);
const streamRegionRef = ref();
const centerUserInfoRef = ref();

const playRegionDomId = computed(() => `${props.stream.userId}_${props.stream.type}`);


const showMasterIcon = computed(() => props.stream.userId === basicStore.masterUserId && props.stream.type === 'main');

const isScreenStream = computed(() => (props.stream.type === 'main' && props.stream.userId?.indexOf('share_') === 0) || props.stream.type === 'screen');


const userInfo = computed(() => {
  let userInfo = props.stream.userName || props.stream.userId;
  if (isScreenStream.value) {
    if (props.stream.userId?.indexOf('share_') === 0 && userInfo === props.stream.userId) {
      userInfo = userInfo.slice(6);
    }
    return `${userInfo} 的屏幕分享`;
  }
  return userInfo;
});

watch(
  () => props.stream.isAudioStreamAvailable,
  async (val) => {
    if (val && props.stream.userId !== basicStore.userId) {
      await nextTick();
      const userIdEl = document.getElementById(`${playRegionDomId.value}`) as HTMLDivElement;
      if (userIdEl) {
        logger.debug(`${logPrefix}watch isAudioStreamAvailable:`, props.stream.userId, userIdEl, ETUIStreamType.CAMERA);
        TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.CAMERA);
      }
    }
  },
  { immediate: true },
);

watch(
  () => props.stream.isVideoStreamAvailable,
  async (val) => {
    if (val && props.stream.userId !== basicStore.userId) {
    // if (val) {
      await nextTick();
      const userIdEl = document.getElementById(`${playRegionDomId.value}`) as HTMLDivElement;
      if (userIdEl) {
        logger.debug(`${logPrefix}watch isVideoStreamAvailable:`, props.stream.userId, userIdEl, ETUIStreamType.CAMERA);
        TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.CAMERA,props.enlargedStreamStyle);
        TUIRoomCore.setRemoteVideoFillMode(
          props.stream.userId as string,
          props.stream.type as string,
          TRTCVideoFillMode.TRTCVideoFillMode_Fit,
        );
      }
    }
  },
  // {
  //   immediate: true,
  //   deep:true
  // },
);

watch(
  () => props.stream.isScreenStreamAvailable,
  async (val) => {
    if (val) {
      await nextTick();
      const userIdEl = document.getElementById(`${playRegionDomId.value}`) as HTMLDivElement;
      if (userIdEl) {
        logger.debug(`${logPrefix}watch isScreenStreamAvailable:`, props.stream.userId, userIdEl, ETUIStreamType.SCREEN);
        TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.SCREEN);
      }
    }
  },
  {
    immediate: true,
    // deep:true
  },
);

// enlargeUserId 切换的时候需要让之前播放流对应的小窗口和需要新播放的流都重新播放
watch(
  () => props.enlargeDomId,
  async (val, oldVal) => {
    console.log(" enlargeUserId 切换的时候需要让之前播放流对应的小窗口和需")
    console.log(val)
    console.log(oldVal)
    if (playRegionDomId.value === oldVal || playRegionDomId.value === val) {
      await nextTick();
      const userIdEl = document.getElementById(`${playRegionDomId.value}`) as HTMLDivElement;
      if (userIdEl) {
        if (basicStore.userId === props.stream.userId) {
          // 只有当本地视频流是打开状态的时候，才重新播放本地流
          if (props.stream.isVideoStreamAvailable) {
            TUIRoomCore.startCameraPreview(userIdEl);
          }
        } else {
          if (props.stream.type === 'main') {
            logger.debug(`${logPrefix}watch enlargeDomId:`, props.stream.userId, userIdEl, ETUIStreamType.CAMERA);
            TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.CAMERA);
          } else if (props.stream.type === 'screen') {
            console.log("enlargeDomId  是不是走到这里来了-----------------------------")
            console.log(props)
            logger.debug(`${logPrefix}watch enlargeDomId:`, props.stream.userId, userIdEl, ETUIStreamType.SCREEN);
            TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.SCREEN);
          }
        };
      }
    }
  },
);

watch(
  playRegionDomId,
  async () => {
    console.log("-------playRegionDomId------------------")
    console.log(playRegionDomId)
    await nextTick();
    const userIdEl = document.getElementById(`${playRegionDomId.value}`) as HTMLDivElement;
    if (userIdEl) {
      if (basicStore.userId !== props.stream.userId) {
        if (props.stream.type === 'main') {
          logger.debug(`${logPrefix}watch playRegionDomId:`, props.stream.userId, userIdEl, ETUIStreamType.SCREEN);
          TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.CAMERA);
        } else if (props.stream.type === 'screen') {
          console.log(props)
          logger.debug(`${logPrefix}watch playRegionDomId:`, props.stream.userId, userIdEl, ETUIStreamType.SCREEN);
          TUIRoomCore.startRemoteView(props.stream.userId as string, userIdEl, ETUIStreamType.SCREEN);
        }
      }
    }
  },
);

// watch(streamRegionRef.value.offsetWidth, () => {
//   centerUserInfoRef.value.style.transform = `scale(${streamRegionRef.value.offsetWidth / 1280})`;
// });

// watch(
//   () => props.stream.isVideoMuted,
//   async (val) => {
//     if (val) {
//       await nextTick();
//       centerUserInfoRef.value.style.transform = `scale(${streamRegionRef.value.offsetWidth / 1280})`;
//     }
//   },
// );


// onMounted(() => {
//   centerUserInfoRef.value.style.transform = `scale(${streamRegionRef.value.offsetWidth / 1280})`;
// });




return { __sfc: true,logPrefix, basicStore, props, layout, userId, streamRegionRef, centerUserInfoRef, playRegionDomId, showMasterIcon, isScreenStream, userInfo, defaultAvatar, AudioIcon, SvgIcon }
}

})